<template>
  <!--
    Account 매핑테이블 조회/수정
  -->
  <div class="content-wrap">
    <div class="search-wrap">
      <div class="row">
        <div class="col-md-2">
          <div class="mb-3">
            <ElLabel name="회사명">
              <template v-slot:end="slotProps">
                <ElInput :id="slotProps.id" v-model="state.searchParams.cmp_nm"  @keyup.enter="searchAccount"/>
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-2">
          <div class="mb-3">
            <ElLabel name="사업부명">
              <template v-slot:end="slotProps">
                <ElInput :id="slotProps.id" v-model="state.searchParams.cmp_dvsn_nm" @keyup.enter="searchAccount"/>
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-2">
          <div class="mb-3">
            <ElLabel name="사업자번호">
              <template v-slot:end="slotProps">
                <ElInput
                 :id="slotProps.id" 
                 ref="businessNoRef"
                 @update:modelValue="bizFormat" 
                 @keyup.enter="searchAccount"
                 :maxlength="12"
                />
              </template>
            </ElLabel>
          </div>
        </div>
        <!-- <div class="col-md-2">
          <div class="mb-3">
            <ElLabel name="영업대표">
              <template v-slot:end="slotProps">
                <ElInput :id="slotProps.id" v-model="state.searchParams.ceo_nm" @keyup.enter="searchAccount"/>
              </template>
            </ElLabel>
          </div>
        </div> -->
        <div class="col-md-2">
          <div class="mb-3">
            <ElLabel name="AM">
              <template v-slot:end="slotProps">
                <ElInput :id="slotProps.id" v-model="state.searchParams.am_nm" @keyup.enter="searchAccount"/>
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-2">
          <div class="mb-3">
            <label for="" class="form-label">회계년도</label>
            <DatePicker v-model="state.searchParams.acc_year" :format="'yyyy'" :year-picker="true" @return="r=>state.searchParams.acc_year = r" :selectDate="state.searchParams.acc_year"/>
            <!-- <select class="form-select" aria-label="Default select example" v-model="state.searchParams.acc_year">
              <option value="">전체</option>
              <option v-for="item of state.fiscalYear.option" :value="item.value">{{ item.name }}</option>
            </select> -->
          </div>
        </div>
        <div class="col-md-2">
          <div class="mb-3">
            
            <ElLabel name="매핑여부">
              <template #end="{id}">
                <div class="form-check">
                  <ElLabel name="매핑">
                    <template #start="{id}">
                      <ElCheckbox
                        v-model="state.searchParams.check_am"
                      />
                    </template>
                  </ElLabel>
                </div>
              </template>
            </ElLabel>

          </div>
        </div>
        
      </div>
    </div>
    <div class="search-detail-wrap"></div>

    <div class="text-end py-2">
      <ElButton type="search" @buttonClick="clickOpenDialog({key:'confirm' , target: [],title :`건을 변경하고자하는 날짜를 선택해주세요.`})">일괄 변경</ElButton>
      <ElButton type="search" @buttonClick="searchAccount()">검색</ElButton>
    </div>

    <div class="d-flex justify-content-between">
      <div></div>
      <div class="table-btn-group">
        <ElButton type="excelDownload" @buttonClick="excelDown()">엑셀다운</ElButton>
      </div>
    </div>
    <div class="table-list table-cf">
      <!--grid 영역-->
      <DataTable :value="state.gridRowData" paginator :rows="10" :rowsPerPageOptions="[10, 20, 50, 100, 200]"
        scrollable scrollHeight="350px"
        removableSort
        @page="onRowsChange"
        >
        <template #empty>
          <div class="center">데이터가 존재하지 않습니다.</div>
        </template>
        <!-- 체크박스 -->
        <Column>
          <template #header>
            <ElCheckbox v-model="allCheck"/>
          </template>
          <template #body="{ data }">
            <ElCheckbox 
              v-model="state.selectRows" 
              :value="data.cp_seq"
            />
          </template>
        </Column>
        <Column v-for="(company,index) of state.gridColumn" :key="index" :field="company.field" :header="company.header">
          <template #body="{ data, field }">
            <!-- 회사 분류 cell 클릭시 모달 open-->
            <div 
            v-if="field.includes('class_nm')" 
            @click="openClsModal(data, 'cl_class_id')"
            :style="company.style">
              <span>{{ data[field] }}</span>
            </div>

            <!-- am cell 클릭시 모달 open   todo-->
            <div v-else-if="field === 'am_nm'"  @click="getUserList(data, field)" :style="company.style">
              <span>{{ data[field] }}</span>
            </div>

            <div 
              v-else-if="field === 'cmp_dvsn_nm'" 
              v-bind:title="data.cmp_dvsn_nm" 
              :style="company.style"
            >
              {{ data.cmp_dvsn_nm }}
            </div>
            <div 
              v-else-if="field === 'cmp_nm'" 
              v-bind:title="data.cmp_nm" 
              :style="company.style"
            >
              {{ data.cmp_nm }}
            </div>
            <div 
              v-else-if="field === 'note'" 
              v-bind:title="data.note" 
              :style="company.style"
            >
              {{ data.note }}
            </div>

            <!--그 외 cell-->
            <div v-else :style="company.style">{{ data[field] }}</div>
          </template>
        </Column>
      </DataTable>
    </div>

    <div class="text-end py-3">
      <!-- <ElButton type="primary" @buttonClick="openExcelUpload()">일괄등록</ElButton> -->
      <ElButton type="primary" @buttonClick="goBack()">이전</ElButton>
      <ElButton type="primary" @buttonClick="updateData()">수정</ElButton>
      <ElButton type="primary" @buttonClick="updateMapping()">매핑완료</ElButton>
    </div>
  </div>

  <excelUtil ref="excelUtilRef" v-show="false" />
  <!-- modal 일괄등록 -->
  <!-- <ExcelUploadModal ref="excelUploadModalRef" :colDefs="state.gridColumn" /> -->
  <ElInput v-show="false" data-bs-toggle="modal" data-bs-target="#amSrModal" ref="amSrModalBtnRef"/>
  <ElInput v-show="false" data-bs-toggle="modal" data-bs-target="#companyClass" ref="companyClassBtnRef"/>
  <ExcelManage v-show="false" ref="excelManage" />
  <dateModalYear ref="dateModalRef"
       @updateValue="handleUpdateValue"
    />
  <CmpClassModal ref="cmpClassModalRef" @return="updateCmpCls"/>
  <UserSearchModal ref="userSearchModalRef" @return="updateUser"/>
</template>

<script setup>
import { reactive, onBeforeMount ,ref, computed } from 'vue';
//component
import excelUtil from '@/components/common/MCO_EX_001.vue';
// import ExcelUploadModal from '@/components/common/modal/ExcelUploadModal.vue';
import ExcelManage from "@/components/common/MCO_EX_001.vue";
import vueRouterCmn from '@/js/vueRouterCmn';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import CmpClassModal from '@/components/common/modal/CmpClassModal.vue';
import UserSearchModal from '@/components/common/modal/UserSearchModal.vue';
import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { accountCompList, getRevIdList, classList, compAccEdit, compYearChange} from '@/api/comp';
import common from '@/js/common';
import DatePicker from '@/components/common/DatePicker.vue'
import dateModalYear from '@/components/common/modal/dateModalYear.vue'

const excelUtilRef = ref()
const amSrModalBtnRef = ref()
// const excelUploadModalRef = ref()
const companyClassBtnRef = ref()
const excelManage = ref();
const cmpClassModalRef = ref()
const userSearchModalRef = ref()
const businessNoRef = ref()
const dateModalRef = ref()
onBeforeMount(async() => {
  
  const res = await classList();
  state.classList = [...res.rtn]
  if(res){
     await searchAccount();
  }
  let date = new Date()
  let year = date.getFullYear()
  year = year - 5
  for (let i = year; i < year + 11; i++) {
    state.fiscalYear.option.push({ name: i, value: i })
  }

  //  setTimeout(function() {
  //    searchAccount()
  //  }, 70); 
 
})

const allCheck = computed({
  get() {
    return state.gridRowData.length === state.selectRows.length;
  },
  set(newValue) {
    state.selectRows = newValue ? state.gridRowData.slice(page.start,page.end).map((item) => { return item.cp_seq }) : [];
  }
})


const state = reactive({
  selectRows: [],
  cmpClsSelectRow: [],
  amSrSelectRow: [],
  gridColumn: [],
  gridRowData: [],
  cmp_update_yn: '',
  maxDepth: 2,
  searchParams: {
    cmp_nm: '',
    am_nm: '',
    cmp_dvsn_nm: '',
    business_no: '',
    ceo_nm: '',
    check_am: true,
    acc_year: common.getThisYear(),
    page_count: 1,
    unit_count: 1000000
  },
  modalSearchParams: {
    enable_yn: 'Y',
    employee_id: '',
    user_id: '',
    user_nm: ''
  },
  fiscalYear: {
    selected: '',
    option: []
  },
  maxRv: '',
  clickRow: {
    rowIndex: '',
    key: ''
  },
  tmpList: [],
  selectDate:''
})

const page = reactive({
  start : 0,
  end : 10
})


const searchAccount = async () => {
  state.selectRows = []
  state.searchParams.fiscalYear = state.fiscalYear.selected
  state.maxDepth = 2
  state.gridColumn = [
    { header: "회계연도", field: "acc_year", style: { minWidth: '80px' }},
    { header: "회사관리번호", field: "cmp_info_seq", style: { minWidth: '150px' } },
    { header: "회사분류1", field: "class_nm1", style: { width: '80px',height: '20px',textOverflow:'ellipsis', overflow:'hidden', whiteSpace:'nowrap',cursor: 'pointer'} },
    { header: "회사분류2", field: "class_nm2", style: { width: '80px',height: '20px',textOverflow:'ellipsis', overflow:'hidden', whiteSpace:'nowrap',cursor: 'pointer' } },
    { header: "회사명", field: "cmp_nm",style:{width: '200px',textOverflow:'ellipsis', overflow:'hidden', whiteSpace:'nowrap'}},
    { header: "사업부", field: "cmp_dvsn_nm",style:{width: '150px',textOverflow:'ellipsis', overflow:'hidden', whiteSpace:'nowrap'}},
    { header: "사업자등록번호", field: "business_no", style: { minWidth: '150px' } },
    { header: "AM", field: "am_nm", style: { minWidth: '150px',height: '20px',cursor: 'pointer' } },
    { header: "메모", field: "note",style:{width: '150px',textOverflow:'ellipsis', overflow:'hidden', whiteSpace:'nowrap'}},
    { header: "적용일자", field: "fmt_app_dt", style: { minWidth: '150px' } },
    { header: "등록일자", field: "fmt_reg_dt", style: { minWidth: '150px' } },
    { header: "수정일자", field: "fmt_upd_dt", style: { minWidth: '150px' } },
  ]
  let param = { ...state.searchParams }
  param.check_am = param.check_am ? 'Y' : ''
  try {
    setIsLoading(true)
    const res = await accountCompList(param)
    state.gridRowData = [...res.rtn].map((item, index) => {
      item.index = index + 1
      //매핑이된 회사분류 아이디값을 이름이랑 매칭 및 3단계 이상일시 그리드 컬럼 추가
      if (item.cl_class_id && item.cl_class_id != '' && item.cl_class_id != undefined) {
        let codeFam = common.findUperCode(item.cl_class_id, state.classList)
        if(codeFam){
          let length = Object.keys(codeFam).length

          if (length > state.maxDepth) {
            for (var i = (state.maxDepth + 1); i <= length; i++) {
              let col = { header: `회사분류${i}`, field: `class_nm${i}`, style: { minWidth: '100px' } }
              // state.listGridOption.colDefs.push(col)
              state.gridColumn.splice(i + 1, 0, col);
              state.maxDepth = i
            }
          }
          codeFam.forEach((code,index)=>{
            item[`class_nm${index+1}`] = code.class_nm
          })
        }
        
      }

      return item
    })
  } catch (err) {
    console.error('/comp/accountCompList ERROR!! => ' + err)
    alert('api 에러 발생!!')
  } finally {
    setIsLoading(false)
  }
}

const clickOpenDialog = (value) =>{
  const {key,target,title} = value
    dateModalRef.value.openDialog(key,target,title)

}

const handleUpdateValue = async(value) =>{
  state.selectDate = value
  try{
    setIsLoading(true);
    const res = await compYearChange({
      selectDate : state.selectDate,
      this_year : common.getThisYear()
    })
    if(res.code !== '0000'){
      alert(res.ex_message);
    }else{
      alert('수정 완료되었습니다.')
      state.searchParams.acc_year = state.selectDate
      await searchAccount();
    }
  } catch(err){
    alert('api 에러 발생!!');
  }finally{
    setIsLoading(false);
  }
  
}


const onRowsChange = (evnet) =>{
  state.selectRows =[]
  page.start = evnet.first
  page.end= evnet.first + evnet.rows
}



const goBack = () => {
  vueRouterCmn.goBack()
}
const fetchRevIdList = async () => {
  try {
    setIsLoading(true)
    const res = await getRevIdList()
    for (let i of res.rtn) {
      if (state.maxRv < i.rev_id) {
        state.maxRv = i.rev_id
      }
    }
  } catch (err) {
    console.error(err)
    alert('회사분류 정보를 불러오는데 실패했습니다.')
  } finally {
    setIsLoading(false)
  }
}


const openClsModal = async (data, field) => {
  state.clickRow.key = field
  state.clickRow.rowIndex = data.index - 1


  // companyClassBtnRef.value.input.click()
  cmpClassModalRef.value.openModal()

}




const getUserList = async (data, field) => {
  state.clickRow.key = field
  state.clickRow.rowIndex = data.index - 1
  userSearchModalRef.value.openUserModal(false)

}



const updateUser = (returnData) => {
  try {
    if (returnData) {
      state.gridRowData[state.clickRow.rowIndex][state.clickRow.key] = returnData.user_nm
      //실제 시퀀스 값 줘야함
      if(state.clickRow.key.includes('am')){
        state.gridRowData[state.clickRow.rowIndex]['am_user_id'] = returnData.employee_id
      }
    }
    checkItem()
    state.clickRow.key = null
    state.clickRow.rowIndex = null
    state.amSrSelectRow = []
  } catch (e) {
    console.log(e)
  }
}

//수정있을경우 체크
const checkItem = () => {
  let key = state.gridRowData[state.clickRow.rowIndex].cp_seq
  let flag = true
  for (let i of state.selectRows) {
    if (i == key) {
      flag = false
    }
  }

  if (flag) {
    state.selectRows.push(key)
  }
}

//저장
const updateData = async () => { 
  if(!state.selectRows.length > 0){
    alert('수정할 항목을 선택해 주세요.')
    return
  }
  let paramList = []
  state.cmp_update_yn = 'Y'

  state.selectRows.forEach((item) => {
    state.gridRowData.forEach((data) => {
      if (item === data.cp_seq) {
        paramList.push(data)
        return
      }
    })
  })

  let successCnt = 0
    try {
      setIsLoading(true)
      for (let param of paramList) {
        param = {
          cp_seq : param.cp_seq,
          cl_rev_id: param.cl_rev_id,
          cl_class_id : param.cl_class_id,
          //sr_user_id : param.am_user_id,
          cmp_update_yn: state.cmp_update_yn,
          acc_year : param.acc_year
        }
        const res = await compAccEdit(param)
        successCnt+=1
      }
    } catch (err) {
      console.error(err)
      alert(`회사관리번호 ${param.cmp_info_seq} 의 수정을 실패했습니다.`)
    } finally {
      alert(`총 ${paramList.length}중에 ${successCnt} 수정했습니다.`)
      setIsLoading(false)
    }
  searchAccount()
}

const updateMapping = async () => {
  if(!state.selectRows.length > 0){
    alert('수정할 항목을 선택해 주세요.')
    return
  }
  let paramList = []
  state.cmp_update_yn = 'N'
  let hasAllAmUserId = true
  state.selectRows.forEach((item) => {
    state.gridRowData.forEach((data) => {
      if (item === data.cp_seq ) {
        if(!data.am_user_id){
          hasAllAmUserId =false
        }
        paramList.push(data)
        return
      }
    })
  })

  let successCnt = 0

  if(hasAllAmUserId){
      try{
        setIsLoading(true)
        for (let param of paramList) {
          param = {
            cp_seq : param.cp_seq,
            cl_rev_id: param.cl_rev_id,
            am_user_id : param.am_user_id,
            //sr_user_id : param.am_user_id,
            cmp_update_yn: state.cmp_update_yn,
            acc_year : param.acc_year  
          }
          const res = await compAccEdit(param)
          successCnt+=1
        }
      } catch(err){
        console.error(err)
        alert(`회사관리번호 ${param.cmp_info_seq} 의 수정을 실패했습니다.`)
      }finally{
        alert(`총 ${paramList.length}중에 ${successCnt} 수정했습니다.`)
        setIsLoading(false)
        searchAccount()
      }
  }else{
    alert('am값은 필수 입니다.')
  }  
}

//엑셀 다운로드
const excelDown = () => {
  let fileNm = "Account 매핑테이블 리스트";
  let header = state.gridColumn;
  let dataList = state.gridRowData;

  if (state.selectRows.length > 0) {
    dataList = state.gridRowData.filter((item) => {
      for (let i of state.selectRows) {
        if (i == item.cp_seq) {
          return item
        }
      }
    })

    excelManage.value.excelDownload(fileNm, header,  dataList);
  } else {
    excelManage.value.excelDownload(fileNm, header,  state.gridRowData);
  }
}

function updateCmpCls(returnData){
  if (returnData.classId) {
    let codeFam = common.findUperCode(returnData.classId,cmpClassModalRef.value.cmpClsList) 

    Object.keys(state.gridRowData[state.clickRow.rowIndex]).forEach((key)=>{
      if(key.includes('class_nm')) state.gridRowData[state.clickRow.rowIndex][key] = ''
    })
    for (let i = 1; i <= codeFam.length; i++) {
      state.gridRowData[state.clickRow.rowIndex][`class_nm${i}`] = codeFam[i-1]['class_nm']
    }

    state.gridRowData[state.clickRow.rowIndex].cl_class_id = returnData.classId
    state.gridRowData[state.clickRow.rowIndex].cl_rev_id = returnData.revId


    if (state.maxDepth < codeFam.length) {

      for (var i = (state.maxDepth + 1); i <= codeFam.length; i++) {
        let col = { header: `회사분류${i}`, field: `class_nm${i}`, style: { minWidth: '100px' } }
        // state.listGridOption.colDefs.push(col)
        state.gridColumn.splice(i + 1, 0, col);
        state.maxDepth = i
      }
    }
    checkItem()

  } else {
    alert('선택된 행이 없습니다.')
  }

}

function bizFormat(data){
  businessNoRef.value.input.value = common.bizNoFormat(data)
  state.searchParams.business_no = businessNoRef.value.input.value
}
</script>